import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { TituloReceberReferenciaData, tituloReceberReferenciasData } from '../titulo-receber-referencia-data';

@Component({
    selector: 'sgt-titulo-receber-referencia-data-select',
    templateUrl: './titulo-receber-referencia-data-select.component.html',
    styleUrls: ['./titulo-receber-referencia-data-select.component.less']
})
export class TituloReceberReferenciaDataSelectComponent implements OnInit {
    referencias = tituloReceberReferenciasData;

    /** Referência */
    @Input() idReferencia: number;
    /** Ao alterar a referência */
    @Output() idReferenciaChange = new EventEmitter<number>();
    /** Referência selecionada */
    referencia: TituloReceberReferenciaData;
    /** Referência alterada */
    @Output() referenciaChange = new EventEmitter<TituloReceberReferenciaData>();
    /** Se pode selecionar nenhuma opção */
    @Input() canSelectNull = true;
    /** Se deve desabilitar o input */
    @Input() disabled: boolean;

    ngOnInit(): void {
        this.referencia = this.referencias.find(referenciaFilter => referenciaFilter.id == this.idReferencia);
    }

    /** Ao selecionar a referência */
    select(referencia: TituloReceberReferenciaData) {
        this.idReferencia = referencia ? referencia.id : null;
        this.idReferenciaChange.emit(this.idReferencia);
        this.referencia = referencia;
        this.referenciaChange.emit(this.referencia)
    }
}
